/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";

import Select from "../select/select";
import { parseValue } from "../../lib/timePickerUtils";

class TimeSelect extends React.Component {
  /**
   * Constructor
   * Set the value of text input in select
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      originalInputValue: props.value ? props.value.label : "",
      inputValue: props.value ? props.value.label : ""
    };
  }

  onInputChange = (inputValue, reason) => {
    // Don't change the value of select input if menu close or set value
    if (reason.action === "menu-close" || reason.action === "set-value") {
      return;
    }

    // If the action is blur, call onBlur handler of parent
    if (reason.action === "input-blur") {
      if (isEmpty(this.state.inputValue)) {
        this.props.clearTimePickerValue();
        return false;
      }

      const { use24Hours, meridiem, allowCustomTime, options } = this.props;
      const { inputValue, originalInputValue } = this.state;
      let parsedValue = null;

      // If 24hours is enabled, parse user input without AM|PM
      // else add AM|PM to the value and then parse. 3rd argument
      // is false to prevent exception throw on blur.
      if (use24Hours) {
        parsedValue = parseValue(inputValue, use24Hours, false);
      } else {
        parsedValue = parseValue(
          `${inputValue} ${meridiem}`,
          use24Hours,
          false
        );
      }

      // If user typed something garbage, do nothing. React select will
      // take care with previous value.
      if (
        !parsedValue ||
        (!allowCustomTime &&
          !options.some(option => option.label === inputValue))
      ) {
        this.setState({ inputValue: originalInputValue });
        return;
      }

      this.props.onInputBlur(parsedValue);
      return;
    }

    // If the action is change value, change the value of current input state
    if (reason.action === "input-change") {
      this.setState({
        ...this.state,
        inputValue
      });
    }
  };

  static getDerivedStateFromProps(props, state) {
    if (props.value === null && state.originalInputValue !== "") {
      return {
        originalInputValue: "",
        inputValue: ""
      };
    }

    if (props.value && props.value.label !== state.originalInputValue) {
      return {
        originalInputValue: props.value.label,
        inputValue: props.value.label
      };
    }
    return state;
  }

  render() {
    const {
      value,
      options,
      onSelect,
      use24Hours,
      selectRef,
      popperPosition,
      disabled,
      placeholder
    } = this.props;
    return (
      <Select
        isDisabled={disabled}
        className={!use24Hours ? "oui-select__hours-12" : ""}
        type="select"
        options={options}
        value={value}
        onChange={onSelect}
        onInputChange={this.onInputChange}
        noOptionsMessage={() => null}
        placeholder={placeholder}
        ref={selectRef}
        menuPosition={popperPosition}
        styles={{
          menu: () => ({
            width: "max-content",
            minWidth: "100%"
          })
        }}
      />
    );
  }
}

TimeSelect.propTypes = {
  selectRef: PropTypes.object,
  use24Hours: PropTypes.bool,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
  value: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number
    })
  ),
  placeholder: PropTypes.string,
  allowCustomTime: PropTypes.bool
};

export default TimeSelect;
